<!--
 * @Version      : V1.0
 * @Date         : 2025-03-25 15:16:29
 * @fileName     : 项目台账
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="项目编号" porp="projectCode">
            <el-input v-model="formInline.projectCode" placeholder="项目编号"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" porp="projectName">
            <el-input v-model="formInline.projectName" placeholder="项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <!-- <el-button type="success" @click="addItem()" v-hasPermi="['project:myProject:add']">新增</el-button> -->
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #projectStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.projectStatus).type" effect="dark">{{ formatterState(row.projectStatus).text }}</el-tag>
          </div>
        </template>

        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <projectDetails ref="myProjectRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></projectDetails>
  </div>
</template>

<script>
import projectDetails from '@/views/project/components/projectDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState } from '@/utils/index'
import { queryProjectForLedgerApi } from '@/api/project/index'
export default {
  components: {
    tableComponent,
    projectDetails
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      detailsT: '项目台账详情',
      formInline: {
        projectCode: "",
        projectName: ""
      },
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "项目编号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectCode", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "项目名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "auto",
          keyName: "projectName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "108px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "客户负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "预计项目金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "estimatedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "项目周期（天）", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectDurationDays", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "130px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
         {
          id: 13,
          title: "项目状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectStatus", // 数据的属性值
          align: "center",
          slotName: "projectStatusSlot", // 插槽名,为空字符串时不使用
        },

        {
          id: 17,
          title: "操作", // 标题名称
fixed:"right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            projectCode: "",
            projectName: "",
            createByName: "",
            ...this.formInline
          }
        },
        ...item
      }
      this.loading = true;
      queryProjectForLedgerApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.projectCode = "";
      this.formInline.projectName = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '项目台账详情'
      this.$refs.myProjectRefs.openDrawer(row)
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
